import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getSplitOrderCount = {
  name: "getSplitOrderCount" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
